export default (prop = '', array = []) =>
  array.sort((a, b) => (a[String(prop)] > b[String(prop)] ? 1 : -1))
